/** Convierte respuestas de error API (string u objeto) a texto para UI. */
export function textoErrorApi(source, fallback = "Error") {
  if (source == null || source === "") return fallback;
  if (typeof source === "string") {
    const s = source.trim();
    if (/error occurred with this application/i.test(s)) {
      return "Error temporal del servidor (posible timeout al subir archivos). Vuelve a pulsar Finalizar.";
    }
    if (/application failed to respond/i.test(s)) {
      return "El servidor no respondió a tiempo (sincronización de portales u otra tarea larga). Recarga la ficha: si el título u otros cambios ya están, no hace falta guardar otra vez; si no, reintenta.";
    }
    if (s.startsWith("<!") || s.includes("<html")) {
      return `${fallback} (respuesta no válida del servidor)`;
    }
    return s;
  }
  if (typeof source === "object") {
    if (typeof source.message === "string" && source.message) return textoErrorApi(source.message, fallback);
    if (typeof source.error === "string" && source.error) return textoErrorApi(source.error, fallback);
    if (source.error != null) return textoErrorApi(source.error, fallback);
  }
  return fallback;
}
